import * as PIXI from 'pixi.js';

const DAMAGE_COLOR = 0xff0600;
const MUTEKI_COLOR = 0xfdf921;

export default class FilterManager {
  static getDamageFilter() {
    return FilterManager._create(DAMAGE_COLOR);
  }

  static getMutekiFilter() {
    return FilterManager._create(MUTEKI_COLOR);
  }

  static _create(color) {
    const filter = new PIXI.filters.ColorMatrixFilter();
    const tint = color;
    const r = (tint >> 16) & 0xff;
    const g = (tint >> 8) & 0xff;
    const b = tint & 0xff;
    filter.matrix[0] = r / 255;
    filter.matrix[6] = g / 255;
    filter.matrix[12] = b / 255;
    return filter;
  }
}
